import {ACTIVE_PROJECT_STORE_PATH} from '../constants'
import {addNamespace} from '@/store/helpers'

// To be used only inside vuex modules
export const _mutations = {
  SET_COMPONENTS: 'setComponents',
  START_LOADING_COMPONENTS: 'startLoadingComponents',
  STOP_LOADING_COMPONENTS: 'stopLoadingComponents',
  SET_ERROR_LOADING_COMPONENTS: 'setErrorLoadingComponents',
  UPDATE_SELECTED_CRITERIA: 'updateSelectedCriteria',
  UPDATE_SEARCH_QUERY: 'updateSearchQuery',
  SET_AVAILABLE_FILTER_CRITERIA: 'setAvailableFilterCriteria',
  SET_ERROR_BUILDING_AVAILABLE_FILTER_CRITERIA: 'setErrorBuildingAvailableFilterCriteria',
  RESET_AVAILABLE_FILTER_CRITERIA: 'resetAvailableFilterCriteria'
}

// To be used publicly outside vuex modules
export const MUTATIONS = addNamespace(
  ACTIVE_PROJECT_STORE_PATH,
  _mutations
)
